export class ChangeFilter { 
    type: string;
    value: any;
  }